
import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';

import '../Resources/dashboard.css';
import axios from '../../axios.js';
import moment from 'moment/moment';
import Sidebar from './sidebar.js';
import Navbar from './navbar.js';

import {useRef as useref} from 'react';
import {useReactToPrint} from 'react-to-print';

function Newcrm_viewreceipt(){


 // const imageUrl = `http://your-domain/storage/Profiles/${imageName}`;

    
    //Report Print Function
    const componentRef = useref();
    const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    });
      
  
   //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const editId=sessionStorage.getItem("EditId00");
 const counterid=sessionStorage.getItem("CounterId00");


 
 useEffect(()=>{
    
   getData();
   
   },[])
  
  


 //SET VARIABLES
 const[receipt_sn,setreceipt_sn]=useState();
 const[receipt_id,setreceipt_id]=useState();
 const[receipt_number,setreceipt_number]=useState();
 const[receipt_date,setreceipt_date]=useState();
 const[receipt_head,setreceipt_head]=useState();
 const[type,settype]=useState();
 const[customer_name,setcustomer_name]=useState();
 const[contact,setcontact]=useState();
 const[email,setemail]=useState();
 const[amount,setamount]=useState();
 const[discount_per,setdiscount_per]=useState();
 const[discount_amount,setdiscount_amount]=useState();
 const[total,settotal]=useState();
 const[sgst_per,setsgst_per]=useState();
 const[sgst_amt,setsgst_amt]=useState();
 const[cgst_per,setcgst_per]=useState();
 const[cgst_amt,setcgst_amt]=useState();
 const[igst_per,setigst_per]=useState();
 const[igst_amt,setigst_amt]=useState();
 const[payable_amount,setpayable_amount]=useState();
 const[amount_paid,setamount_paid]=useState();
 const[payment_status,setpayment_status]=useState();
 const[payment_mode,setpayment_mode]=useState();
 const[transaction_id,settransaction_id]=useState();
 const[receipt_remarks,setreceipt_remarks]=useState();
 const[date_updated,setdate_updated]=useState();
 const[time_updated,settime_updated]=useState();

 const[errorvar,seterrorvar]=useState();
 

//******************* VIEW RECEIPT DATA FUNCTION START  ********************//
function getData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((editId!=null)||(editId!=" "))){
  
 axios.post("newcrm-get-receipt-byid", {
   Log_id:logid,
   Token:token,
 //  Busy_id:busyid,
 //  Counter_id:counterid,
   Sn_start :0,
   Sn_end :0,
   Sn_total :0,
   Sn_limit :0,
   Filter_val : 0,
   Edit_id : editId,

   
   //Code Edits for pagination
   'page' : 0


   })
 .then((response) => {


  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");

     window.location.replace("/");
  }
  //Success Data Fetched
  if(response.data.successvar==1){

   //Setting Data
  // setData(response.data.data.data);
  setreceipt_sn(response.data.receipt_sn);
  setreceipt_id(response.data.receipt_id);
  setreceipt_number(response.data.receipt_number);
  setreceipt_date(response.data.receipt_date);
  setreceipt_head(response.data.receipt_head);
  settype(response.data.type);
  setcustomer_name(response.data.customer_name);
  setcontact(response.data.contact);
  setemail(response.data.email);
  setamount(response.data.amount);
  setdiscount_per(response.data.discount_per);
  setdiscount_amount(response.data.discount_amount);
  settotal(response.data.total);
  setsgst_per(response.data.sgst_per);
  setsgst_amt(response.data.sgst_amt);
  setcgst_per(response.data.cgst_per);
  setcgst_amt(response.data.cgst_amt);
  setigst_per(response.data.igst_per);
  setigst_amt(response.data.igst_amt);
  setpayable_amount(response.data.payable_amount);
  setamount_paid(response.data.amount_paid);
  setpayment_status(response.data.payment_status);
  setpayment_mode(response.data.payment_mode);
  setsgst_per(response.data.sgst_per);
  settransaction_id(response.data.transaction_id);
  setreceipt_remarks(response.data.receipt_remarks);
  setdate_updated(response.data.date_updated);
  settime_updated(response.data.time_updated);


  }

  //Cannot Fetch Data
  else{
   seterrorvar("Cannot Fetch Data !");
  }
 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");


   window.location.replace("/");
 
  }
 
 }
  
 //******************* VIEW RECEIPT DATA FUNCTION END  ********************//





 return(
    <>
 
 <html lang="en">
 <head>
   {/*} Required meta tags */}
   <meta charset="utf-8" />
   <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
   <title>BUSINESS SAMADHAN | CRM</title>
   {/*} plugins:css */}
   <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
   <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
   <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
   {/*} endinject */}
   {/*} Plugin css for this page */}
   <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
   <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
   {/*} End plugin css for this page */}
   {/*} inject:css */}
   {/*} endinject */}
   {/*} Layout styles */}
   <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
   {/*} End layout styles */}
   <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
 </head>
 <body>


   <div class="container-scroller">

   {/*} <Sidebar /> */}
   <div class="container-fluid page-body-wrapper">




      <Navbar />
       {/*} partial */}
       <div class="main-panel">

       
          
         

         <div class="content-wrapper pb-0">

         <div class="page-header flex-wrap">
            <div class="header-left"></div>
              <div class="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div class="d-flex align-items-center">
                  <a href="#">
                    <p class="m-0 pe-3">VIEW RECEIPT</p>
                  </a>
                  <a class="ps-3 me-4" href="#">
                    <p class="m-0"></p>
                  </a>
                </div>
                  <button type="button" class="btn btn-primary mt-2 mt-sm-0 btn-icon-text" onClick={handlePrint}>
                  <i class="mdi mdi-printer"></i>Print</button>
              
              </div>
            </div>

         
            {/* CREATE RECEIPT FORM START */}
                   <div class="row">
                       <div class="col-12 grid-margin">
                    


           <div class="card"  id="receipt" ref={componentRef}>
           {/* HEADER SECTION START */}
           <div class="d-flex justify-content-between mt-5">
               <div style={{marginLeft:"5rem"}}>
                <img src="./images/imglogo.jpg" style={{height:"7rem", width:"14rem"}} />
               </div>
               <div style={{marginRight:"5rem"}}>
                
                 <h3 class="text-danger mt-3">RECEIPT</h3>
                 </div>
               </div>

               <div class="d-flex justify-content-between" style={{textAlign:"left"}}>
               <div style={{marginLeft:"5rem"}}>
               <p><b>Receipt Number: </b> <span >{receipt_number}</span></p>
               <p><b>Receipt Date: </b> <span >{receipt_date}</span></p>
               </div>
               <div style={{marginRight:"5rem"}}>
                
               <p><b>Transaction Id: </b> <span >{transaction_id}</span></p>
               <p><b>Type: </b> <span >{type}</span></p>
                 </div>
               </div>
               <hr/>




                {/* HEADER SECTION END */}

             <div class="card-body" style={{textAlign:"left", marginLeft:"5rem", marginRight:"5rem"}}>
             <div class="row">
                   <div class="col-md-4"><p><b>Customer Name: </b> <span >{customer_name}</span></p></div>
                   <div class="col-md-4"><p><b>Contact: </b> <span >{contact}</span></p></div>
                   <div class="col-md-4"><p><b>Email: </b> <span >{email}</span></p></div>
             </div>
             <div class="row">
                   <div class="col-md-4"><p><b>Receipt Title: </b> <span >{receipt_head}</span></p></div>
                   <div class="col-md-4"><p><b>Payment Mode: </b> <span >{payment_mode}</span></p></div>
                   <div class="col-md-4"><p><b>Payment Status: 
                   <span class="text-success" hidden={(payment_status=="due")||(payment_status=="partially paid")||(payment_status=="cancelled")}>paid</span> 
                   <span class="text-danger" hidden={(payment_status=="paid")||(payment_status=="partially paid")||(payment_status=="cancelled")}>due</span> 
                   <span class="text-warning" hidden={(payment_status=="due")||(payment_status=="paid")||(payment_status=="cancelled")}>partially paid</span> 
                   <span class="text-danger" hidden={(payment_status=="due")||(payment_status=="paid")||(payment_status=="partially paid")}>cancelled</span> 
                   </b></p></div>
             </div>
               
             <div class="table-responsive mt-5">
             <table class="table table-bordered">
             <thead>
                <tr>
                    <th class="col-8"  style={{fontWeight:"bold"}}>Particular</th> 
                    <th class="col-4" style={{fontWeight:"bold"}}>Amount</th> 
                </tr>
             </thead>
             <tbody>
                <tr>
                    <td class="col-8">Amount</td>
                    <td class="col-4">{amount}</td>
                </tr>
                <tr>
                    <td class="col-8">Discount @ {discount_per} %</td>
                    <td class="col-4">{discount_amount}</td>
                </tr>
                <tr>
                    <td class="col-8"><b>Total</b></td>
                    <td class="col-4"><b>{total}</b></td>
                </tr>
                <tr>
                    <td class="col-8">SGST @ {sgst_per} %</td>
                    <td class="col-4">{sgst_amt}</td>
                </tr>
                <tr>
                    <td class="col-8">CGST @ {cgst_per} %</td>
                    <td class="col-4">{cgst_amt}</td>
                </tr>
                <tr>
                    <td class="col-8">IGST @ {igst_per} %</td>
                    <td class="col-4">{igst_amt}</td>
                </tr>
                <tr>
                    <td class="col-8"><b>Total Payable Amount</b></td>
                    <td class="col-4"><b>{payable_amount}</b></td>
                </tr>
                <tr>
                    <td class="col-8">Amount Paid</td>
                    <td class="col-4">{amount_paid}</td>
                </tr>
            {/*}    <tr>
                    <td class="col-8">Amount Due</td>
                    <td class="col-4">{}</td>
                </tr> */}
             </tbody>
             </table>
             </div>

              

               <div class="form-sample mt-3">
                 <p><b>Remarks: </b><span>{receipt_remarks}</span></p>
                 
                 <p>Generated By:<span>Technomate Startup Services Private Limited <br/>LIG C-5 90 Quarter sanjeevani nagar Jabalpur (M.P.), India - 482001.</span></p>
                 <p>Corporate Identification Number (CIN) : <span>U74999MP2022PTC064036</span></p>
                 <p>GSTIN: <span>23AAJCT8760E1Z7</span></p>
                 <p>For any queries, write to us at: <span>help.startupconnect@gmail.com</span></p>
               
               </div>
               <hr/>
               <div>
                <p class="text-center text-muted">this is a software generated receipt, no seal or sign is required.</p>
                <p class="text-center text-muted">created on {date_updated} ({time_updated})</p>
               </div>
             </div>
           </div>
      
                   
                   </div>
               </div>
            
              
       
     </div>
     {/*} content-wrapper ends */}
     {/*} partial:partials/_footer.html */}
   {/*}  <footer class="footer">
       <div class="d-sm-flex justify-content-center justify-content-sm-between">
         <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
         <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i class="mdi mdi-heart text-danger"></i></span>
       </div>
     </footer> */}
     {/*} partial */}
   </div>
   {/*} main-panel ends */}
 </div>
 {/*} page-body-wrapper ends */}
</div>
{/*} container-scroller */}
{/*} plugins:js */}
<script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
{/*} endinject */}
{/*} Plugin js for this page */}
<script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
<script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
<script src="panel/assets/vendors/flot/jquery.flot.js"></script>
<script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
<script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
<script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
<script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
<script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
{/*} End plugin js for this page */}
{/*} inject:js */}
<script src="panel/assets/js/off-canvas.js"></script>
<script src="panel/assets/js/hoverable-collapse.js"></script>
<script src="panel/assets/js/misc.js"></script>
<script src="panel/assets/js/settings.js"></script>
<script src="panel/assets/js/todolist.js"></script>
{/*} endinject */}
{/*} Custom js for this page */}
<script src="panel/assets/js/dashboard.js"></script>
{/*} End custom js for this page */}
</body>
</html>
</>

);

}
//}

export default Newcrm_viewreceipt;